import React from 'react';
import { IconAddCircular } from './icons/icon-add--circular';
import { IconArrowRight } from './icons/icon-arrow-right';
import { IconCalendar } from './icons/icon-calendar';
import { IconCheckCircular } from './icons/icon-check--circular';
import { IconClose } from './icons/icon-close';
import { IconExclamationCircular } from './icons/icon-exclamation--circular';
import { IconFile } from './icons/icon-file';
import { IconFolder } from './icons/icon-folder';
import { IconGeolocation } from './icons/icon-geolocation';
import { IconQuestionCircular } from './icons/icon-question--circular';
import { IconTranslate } from './icons/icon-translate';
import { IconTrash } from './icons/icon-trash';
import { IconDropdown } from './icons/icon-dropdown';
import { IconArrow } from './icons/icon-arrow';
import { IconThreeDots } from './icons/icon-three-dots';
import { IconContract } from './icons/icon-contract';
import { IconExpand } from './icons/icon-expand';
import { IconAxisTitle } from './icons/icon-axis-title';

export type IconList = (
  'arrow-right' |
  'calendar' |
  'close' |
  'file' |
  'folder' |
  'geolocation' |
  'translate' |
  'trash' |
  'add--circular' |
  'check--circular' |
  'exclamation--circular' |
  'question--circular' |
  'dropdown' |
  'arrow' |
  'expand' |
  'contract' |
  'three-dots' |
  'axis-title'
)

export type IconProps = {
  type: IconList,
  className?: string,
  onClick?: ()=> void,
};

export type IconTypeProps = {
  className: string,
  onClick: ()=> void
}

export function Icon({
  type,
  className='',
  onClick=()=>{},
  ...rest
}: IconProps) {
  switch (type) {
    case 'arrow-right': return <IconArrowRight className={className} onClick={onClick} {...rest} />
    case 'calendar': return <IconCalendar className={className} onClick={onClick} {...rest} />
    case 'close': return <IconClose className={className} onClick={onClick} {...rest} />
    case 'file': return <IconFile className={className} onClick={onClick} {...rest} />
    case 'folder': return <IconFolder className={className} onClick={onClick} {...rest} />
    case 'geolocation': return <IconGeolocation className={className} onClick={onClick} {...rest} />
    case 'translate': return <IconTranslate className={className} onClick={onClick} {...rest} />
    case 'trash': return <IconTrash className={className} onClick={onClick} {...rest} />
    case 'add--circular': return <IconAddCircular className={className} onClick={onClick} {...rest} />
    case 'check--circular': return <IconCheckCircular className={className} onClick={onClick} {...rest} />
    case 'exclamation--circular': return <IconExclamationCircular className={className} onClick={onClick} {...rest} />
    case 'question--circular': return <IconQuestionCircular className={className} onClick={onClick} {...rest} />
    case 'dropdown': return <IconDropdown className={className} onClick={onClick} {...rest} />
    case 'arrow': return <IconArrow className={className} onClick={onClick} {...rest} />
    case 'three-dots': return <IconThreeDots className={className} onClick={onClick} {...rest} />
    case 'contract': return <IconContract className={className} onClick={onClick} {...rest} />
    case 'expand': return <IconExpand className={className} onClick={onClick} {...rest} />
    case 'axis-title': return <IconAxisTitle className={className} onClick={onClick} {...rest} />
    default: return null
  }
}
